import { FaArrowRight } from "react-icons/fa";
import { Link } from "react-router-dom";
import "./linkdropdown.css";
import { useState } from "react";

interface LinkItem {
  name: string;
  to: string;
  description: string;
}

interface LinkDropdownProps {
  links: LinkItem[];
  isSidebar?: boolean;
}

const LinkDropdown: React.FC<LinkDropdownProps> = ({ links, isSidebar }) => {


  const [hoveredItems, setHoveredItems] = useState(Array(links.length).fill(false));

  const handleMouseEnter = (index:number) => {
    const updatedHoveredItems = [...hoveredItems];
    updatedHoveredItems[index] = true;
    setHoveredItems(updatedHoveredItems);
  };

  const handleMouseLeave = (index:number) => {
    const updatedHoveredItems = [...hoveredItems];
    updatedHoveredItems[index] = false;
    setHoveredItems(updatedHoveredItems);
  };
  return (
    <div className="link-dropdown-container">
      {links.map((link, index) => (
        <div key={index} className="dropdown-link-holder">
          <Link to={link.to} className="link-item">
            <div
              className="item-content"
              style={
                isSidebar
                  ? {
                      borderBottom: "1px solid rgb(204, 204, 204)",
                      marginBottom: 20,
                      paddingBottom: 5,
                    }
                  : {}
              }
              onMouseEnter={() => handleMouseEnter(index)}
              onMouseLeave={() => handleMouseLeave(index)}
            >
              <h1 style={isSidebar ? { fontWeight: 400, fontSize: 18,  color: hoveredItems[index] ? "#00aeef" : "grey" } : {}} >{link.name}</h1>

              {isSidebar ? null : (
                <div className="arrow-right">
                  <FaArrowRight color="#00AEEF" />
                </div>
              )}
            </div>
            {isSidebar ? null : (
              <p style={{ color: "grey" }}>{link.description}</p>
            )}
          </Link>
        </div>
      ))}
    </div>
  );
};

export default LinkDropdown;
